module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/+app-custom/components/publication-registration/step-new-publication/step-new-publication.component.scss
// module id = ./src/app/+app-custom/components/publication-registration/step-new-publication/step-new-publication.component.scss
// module chunks = main